import { render, staticRenderFns } from "./DetailCarousel.vue?vue&type=template&id=c82d575a&"
import script from "./DetailCarousel.vue?vue&type=script&lang=js&"
export * from "./DetailCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DetailCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports